var OCS = OCS || {}; //TODO: Build out a means to disable the legend and re-enable it in the new panel when dragged to a new location and have it as a feature of the map
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};

OCS.Viewer.Classes.LegendMapFeature = new Class({
    legend_visible: false,
    legend_layer_group: null,
    legend_mouse_removal_timeout: null,
    legend_mouse_events_active: false,
    bound_events: {},
    init_legend: function () {
        this.bound_methods[OCS.Viewer.Config.events.TOGGLE_LAYER_LEGEND_VISIBILITY] = this.toggle_layer_legend_visibility.bind(this);
        this.addEvent('layer_group_added', this.on_legend_layer_group_added.bind(this));
        this.bound_events.legend_mouse_over = this.legend_mouse_over.bind(this);
        this.bound_events.legend_mouse_click = this.legend_mouse_click.bind(this);
    },
    on_legend_layer_group_added: function (lg) {
        var hc = this.get_html_controller();
        if (lg && lg.has_legend && hc) {
            lg.addEvent('layer_legend_activated', this.on_layer_legend_activated.bind(this));
            lg.addEvent('layer_legend_deactivated', this.on_layer_legend_deactivated.bind(this));
            if(hc.legend_container) {
                lg.set_container(hc.legend_container.legend_content_container);
            } else {
                hc.addEvent('legend_container_created', lg.bound_methods.on_legend_container_created);
            }
            
        }
    },
    on_layer_legend_activated: function (group) {
        this.fireEvent('mouse_listener', true);
        this.layer_legend_visibility(group.id, true);
        this.add_legend_mouse_events();

    },
    on_layer_legend_deactivated: function (group) {
        this.layer_legend_visibility(group.id, false);
        this.remove_legend_mouse_events();
        this.fireEvent('mouse_listener', false);
    },
    add_legend_mouse_events: function () {
        if (this.legend_mouse_removal_timeout) {
            clearTimeout(this.legend_mouse_removal_timeout);
        }
        if (!this.legend_mouse_events_active) {
            this.addEvent('mouse_move', this.bound_events.legend_mouse_over);
            this.addEvent('mouse_click', this.bound_events.legend_mouse_click);
            this.legend_mouse_events_active = true;
        }
    },
    remove_legend_mouse_events: function () {
        if (!this.legend_mouse_removal_timeout) {
            this.legend_mouse_removal_timeout = setTimeout(function () {
                if (this.legend_mouse_events_active) {
                    this.removeEvent('mouse_move', this.bound_events.legend_mouse_over);
                    this.removeEvent('mouse_click', this.bound_events.legend_mouse_click);
                    this.legend_mouse_events_active = false;
                    this.legend_mouse_removal_timeout = null;
                }
            }.bind(this), 1000);
        }
    },

    display_legend_tooltip: function (in_mouse_position) {
        var hc = this.get_html_controller();
        if (hc && this.legend_layer_group) {
            var trackLonLat = ol.proj.transform(in_mouse_position, OCS.Viewer.Config.default_projection, OCS.Viewer.Config.default_display_projection);
            hc.update_map_controls_legend(this.legend_layer_group.get_legend_tooltip_text(trackLonLat), this.legend_layer_group.get_legend_status_text(trackLonLat), this.legend_layer_group.get_frac(trackLonLat));
        }
    },

    get_legend_visible: function () {
        return this.legend_visible;
    },
    toggle_layer_legend_visibility: function (group_obj) {
        var group = this.layer_groups[group_obj.id];
        var hc = this.get_html_controller();
        if (hc && hc.legend_container && group && group.has_legend) {
            var vis;
            if (this.legend_visible) {
                vis = false;
            } else {
                vis = true;
            }
            if (this.legend_layer_group && this.legend_layer_group.id !== group.id) {
                // Turn off the existing legend and turn on the new one
                this.toggle_layer_legend_visibility(this.legend_layer_group);
                vis = true;
            }
            this.legend_visible = vis;
            if (vis) {
                this.legend_layer_group = group;
                hc.legend_container.show();
                group.fireEvent('activate_layer_legend');
            } else {
                group.fireEvent('deactivate_layer_legend');
                hc.legend_container.hide();
                this.legend_layer_group = null;
            }
        }

    },
    layer_legend_visibility: function (group_id, legend_visibility) {
        var map_cntrllr = this.get_map_controller();
        if (map_cntrllr) {
            map_cntrllr.get_panel_options().fireEvent(OCS.Viewer.Config.events.LAYER_LEGEND_VISIBILITY_CHANGED, {group_id: group_id, condition: legend_visibility});
        }
    },
    legend_mouse_click: function (e) {
        var mouse_position = this.get_mouse_position();
        if (this.legend_layer_group && this.legend_visible && mouse_position && mouse_position.length === 2) {
            this.legend_layer_group.mouse_click(mouse_position, parseFloat(this.map_view.get_resolution()));
        }
        //this.handle_mouse_click(e, mouse_position);
    },
    legend_mouse_over: function (e) {
        var mouse_position = this.get_mouse_position();
        if (this.legend_layer_group && this.legend_visible && mouse_position && mouse_position.length === 2) {
            this.display_legend_tooltip(mouse_position);
            this.legend_layer_group.mouse_over(mouse_position, parseFloat(this.map_view.get_resolution()));


        }
        //this.handle_mouse_over(e, mouse_position);
    },

});